export { default, type IconImageProps } from './IconImage';
